module.exports = __webpack_public_path__ + "teg/media/DedicatedAndFixed.ca8a75db.jpg";